// extracted by mini-css-extract-plugin
export var readonly = "_es-1";
export var star = "_es-0";